<div class="container container-profile">

  <div class="card card-white">

    <div class="card-body">

      <h3 class="page-title">
        {{ 'Follow-up days' | translate }}
      </h3>

      <table class="table table-striped table-fixed full" *ngIf="view.data.length > 0">
        <thead>
        <tr>
          <th>
            {{ 'Company' | translate}}
          </th>
          <th>
            {{ 'Title' | translate}}
          </th>
          <th>

          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let experienceday of view.data">
          <td>
            {{experienceday['company']['name']}}
          </td>
          <td>
            {{experienceday['title']}}
          </td>
          <td class="text-right">
            <a class="btn btn-primary" [routerLink]="'/companies/' + experienceday['companyId'] + '/experienceday'">
              {{ 'View' | translate }}
            </a>
          </td>
        </tr>
        </tbody>
      </table>

      <div *ngIf="view.data.length == 0">
        {{ 'No results' | translate }}
      </div>

    </div>

  </div>

</div>
